<div>
  <h1>{{ errorMessageTitle }}</h1>
</div>
<div class="icbc-alert-box icbc-alert-box-important-with-border">
  <img class="icbc-alert-icon" src="assets/images/error.svg">
  <span [innerHTML]="errorMessage"></span>
</div>
